import { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import logo from "../assets/logo.png";
import apiendpoints from "../apiendpoints.json";
import { toast } from "react-toastify";
import ReCAPTCHAComponent from "./GoogleCaptcha/googleCaptcha";
import stump from "../assets/stump.png";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const emailValidation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneValidation = /^(?:\+?\d{1,3}[ -]?)?(?:\d{3,5}[- ]?)?\d{10}$/;

  const navigation = useNavigate();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
 const[loader,setloader]=useState(false)
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  // const [phone, setPhone] = useState("");
 // const [error, setError] = useState("");
  const [error, setError] = useState("");
  // const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [buttonEnable, setButton] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const handleCaptchaChange = (value) => {
  //   setIsCaptchaValid(!!value);
  // };

  // const inputFocus = useRef(null);

  const inputFocus = useRef(null);
const [isFocused, setIsFocused] = useState(false);
const [phoneError, setPhoneError] = useState("");
const [emailError, setEmailError] = useState("");
const validate = () => {
  let valid = true;

  if (!emailValidation.test(email)) {
    setEmailError("Invalid email address");
    valid = false;
  } else {
    setEmailError("");
  }

  if (!phoneValidation.test(phone)) {
    setPhoneError("Invalid phone number");
    valid = false;
  } else {
    setPhoneError("");
  }

  return valid;
};

const handlefocus = () => {
  if (inputFocus.current) {
    inputFocus.current.scrollIntoView({ behavior: "smooth", block: "start" });
    inputFocus.current.focus();
    setIsFocused(true); // Add green border
  }
};

  // const handlefocus = () =>{
  //   inputFocus.current.focus()
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return; // Stops form submission if validation fails
    }
    if(validate()){
      setloader(true);
    }
    
    setButton(true);
    setloader(true);
    setIsSubmitting(true);
    // if (!isCaptchaValid) {
    //   toast.error("Please verify reCAPTCHA");
    //   setButton(true);
    //   return;
    // }

    const formData = {
      nameUser: name,
      mobile: phone,
      email: email,
      message: message,
      entity: "equity",
    };

    try {
      const response = await fetch(apiendpoints.enquiryUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          entity: "equity",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Failed to send message:", response.status, errorText);
        toast.error("Failed to send message");
        return;
      }
      window.open("/thanks", "_blank");
      // toast.success("Thank you for reaching out to us. We will get back to you soon..", {
      //   position: "top-right",
      // });
      setName("");
      setPhone("");
      setEmail("");
      setMessage("");
      // navigation("/thanks");
      
      // setIsCaptchaValid(false);
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message");
    } finally {
      setButton(true);
      setloader(false);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white">
      <div className="relative pt-4">
        <svg
          className="absolute inset-0 -z-10 h-full w-full stroke-gray-400 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-200/80">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect
            width="100%"
            height="100%"
            strokeWidth={0}
            fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
          />
        </svg>
        <div className="mx-auto max-w-8xl block justify-between  lg:flex lg:gap-x-8 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0 lg:flex-auto z-[50]">
            <div className="flex">
              <div className="relative flex items-center gap-x-4 px-4 py-1 ">
                <img src={logo} alt="logo" className="w-32 h-32" />
              </div>
            </div>
            <h1 className="mt-4 max-w-xl text-4xl mx-1 font-bold tracking-tight text-gray-900 sm:text-5xl">
              We prioritize customer relationships{" "}
            </h1>
            <p className="mt-6 text-lg text-gray-800 font-light mx-1">
              Welcome to Equity Research Mart, emerging SEBI-Registered insights
              with advanced research. Empowering you with actionable
              recommendations, comprehensive solutions, and personalized
              support.
            </p>

            <div className="mt-10 flex items-center gap-x-6 mx-1">
              <a
                onClick={handlefocus}
                href="#"
                className="rounded-md bg-[#007cc0] px-1 lg:px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#007cc0]/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                Get started
              </a>
              <a
                href="#"
                className="text-sm font-semibold leading-6 text-gray-900"
              >
                Learn more <span aria-hidden="true">→</span>
              </a>
              <div className="w-1/3 lg:w-1/3 z-1 lg:ml-28 ml-3">
                <img src={stump} alt="" />
              </div>
            </div>
          </div>
          <div className=" z-[50]  lg:mt-0 lg:flex-shrink-0 lg:flex-grow mb-5 lg:h-full focus:outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" ref={inputFocus}>
            <section ref={inputFocus}
    className={`mt-20 z-[50] lg:mt-0 pt-3  lg:pt-0 lg:flex-shrink-0 lg:flex-grow lg:mb-5 lg:h-full min-h-screen pb-3 bg-blue-950 px-2 lg:mx-20 lg:w-4/5 focus:outline-none ${
      isFocused ? "border-4 border-purple-600  rounded-lg" : "border-blue-600 border rounded-lg"
    }`}>
              <div className=" lg:py-8  max-w-lg min-h-screen">
                <h2 className="mb-4 mx-0 px-0 text-2xl w-full font-bold text-gray-100 ">
                  Book your Free Slot & Start Profit Booking
                </h2>
                <div className="px-4 lg:py-4 flex justify-center">
                  <p className="py-2 rounded-lg shadow-lg bg-cyan-800 text-white lg:w-2/3 w-[95%] font-semibold text-center">
                    SEBI-Registered :{" "}
                    <span className="font-normal tracking-wide">
                      INH000016700
                    </span>
                  </p>
                </div>
                <form
                
                  onSubmit={handleSubmit}
                  className="space-y-4 flex-col items-center px-8 mx-auto lg:pt-0 pt-20 h-full"
                >
                  <div>
                    <label
                      htmlFor="name"
                      className="block mb-2 text-sm font-medium text-gray-100"
                    >
                      <span className="text-red-500">*</span>Your Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="shadow-sm bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-full focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                      placeholder="Enter your name here"
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="phone"
                      className="block mb-2 text-sm font-medium text-gray-100"
                    >
                      <span className="text-red-500">*</span>Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      value={phone}
                      // onChange={(e) => {
                      //   let input = e.target.value.replace(/[^0-9+]/g, ""); 
                        
            
                      //   if (input.includes("+") && input.indexOf("+") !== 0) {
                      //     input = input.replace(/\+/g, "");
                      //   }
                  
                      //   setPhone(input);
                      // }}
                       maxLength={15}
                       minLength={10}
                      onChange={(e) => setPhone(e.target.value)}
                      className="shadow-sm bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-full focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                      placeholder="Enter your mobile/cell number"
                      required
                    />
                    {phoneError && <p className="text-red-500 text-sm">{phoneError}</p>}
                  </div>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-gray-100  w-full"
                    >
                      <span className="text-red-500">*</span>Your Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="shadow-sm bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-full focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 "
                      placeholder="Enter your email address"
                      required
                    />
                    {emailError && <p className="text-red-500 text-sm">{emailError}</p>}
                  </div>

                  <div className="sm:col-span-2">
                    <label
                      htmlFor="message"
                      className="block mb-2 text-sm font-medium text-gray-100 "
                    >
                      <span className="text-red-500">*</span>Your Message
                    </label>
                    <textarea
                      id="message"
                      rows="6"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className="block p-2.5 w-full text-sm text-gray-500 bg-gray-100 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 "
                      placeholder="Mention the subject/message you want us to know"
                    ></textarea>
                  </div>
                  {/* <div className="md:col-span-2 lg:col-span-3">
                    <ReCAPTCHAComponent onChange={handleCaptchaChange} />
                  </div> */}

                  <button
                    type="submit"
                    className="py-2 px-5 bg-[#007cc0] text-md font-light text-white rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300"
                    disabled={isSubmitting}
                  >
                    {loader ? "Submitting..." : "Submit"}
                  </button>
                </form>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
